export default __webpack_public_path__ + "static/media/sql.67e297cc.png";